import { cx } from '@/components/form/utils';

export interface StepDef {
  id: string;
  label: string;
  icon: string;
}

interface Props {
  steps: StepDef[];
  current: number;
  onJump?: (index: number) => void;
}

export const Stepper = ({ steps, current, onJump }: Props) => (
  <div className="flex items-center gap-0 overflow-x-auto border-b-[3px] border-teal bg-white px-5">
    {steps.map((s, i) => {
      const active = i === current;
      const done = i < current;
      return (
        <div key={s.id} className="flex items-center">
          <button
            type="button"
            onClick={() => onJump?.(i)}
            className={cx(
              '-mb-[3px] flex items-center gap-2 whitespace-nowrap border-b-[3px] px-4 py-3.5 text-[10px] font-bold uppercase tracking-wide transition-colors',
              active
                ? 'border-teal text-teal'
                : done
                  ? 'border-transparent text-navy'
                  : 'border-transparent text-ink-300',
            )}
          >
            <span
              className={cx(
                'flex h-[26px] w-[26px] items-center justify-center rounded-full text-[10px]',
                active
                  ? 'bg-teal text-navy'
                  : done
                    ? 'bg-navy text-white'
                    : 'bg-[#e0e6f0] text-ink-500',
              )}
            >
              <i className={`fas ${s.icon}`} />
            </span>
            {s.label}
          </button>
          {i < steps.length - 1 && (
            <i className="fas fa-chevron-right px-1 text-[9px] text-ink-200" />
          )}
        </div>
      );
    })}
  </div>
);
